import _ from 'lodash'

const STATUS_OPEN = 'open'
const STATUS_CLOSED = 'closed'

export const Status = {
  OPEN: STATUS_OPEN,
  CLOSED: STATUS_CLOSED,
}

export default class EndorsementModel {
  id = null
  name = null
  tag = null
  description = null
  extraPremium = null
  extraPremiumCurrencyCode = null
  status = null
  dueDate = null
  xDays = null
  coins = null
  valuation = null
  limit = null
  limitCurrencyCode = null
  deductible = null
  deductibleCurrencyCode = null
  libraryId = null
  data = null
  nameWithTag = null
  index = null
  showDescription = true
  groups = []
  productId = null
  product = null

  constructor(data = {}) {
    _.forEach(data, (value, field) => {
      this[_.camelCase(field)] = value
    })
  }
}
